import { downloadAsset, helperCreateObjectUrl } from "~/solidJs/shared/helpers";
import { initVideoViewerHoverMenu } from "~/solidJs/widgets/HoverFeatureMenu";
import Viewer from "../viewer";

export default class VideoViewer extends Viewer {
	static type = "video";
	static supportedExtensions = ["mp4", "mov"];

	constructor(asset, socketOutput, socketName) {
		super(asset, socketOutput, socketName);
		this.initSizeDom();

		// Initialize new hover feature menu
		if (socketOutput && socketName) {
			this.hoverMenuCleanup = initVideoViewerHoverMenu(this, socketOutput, socketName);
		}
	}

	handleDownload() {
		if (this.asset) {
			downloadAsset(this.asset);
		}
	}

	initSizeDom() {
		const parent = this.dom.viewerContainer;
		this.dom.sizeContainer = document.createElement("div");
		this.dom.sizeContainer.className =
			"text-2xs flex absolute left-0 bottom-0 gap-2 flex-col rounded-md p-1 bg-white";
		parent.append(this.dom.sizeContainer);
	}

	changeVideoTextSize(height, width) {
		this.dom.sizeContainer.textContent = `size ${width} x ${height}`;
	}

	loadAsync() {
		const url = helperCreateObjectUrl(this.asset);
		this.dom.content = document.createElement("div");
		this.dom.content.style.width = "100%";
		this.dom.content.style.height = "100%";

		this.dom.video = document.createElement("video");
		this.dom.video.className = "h-full w-full";
		this.dom.video.controls = true;
		this.dom.video.autoplay = true;
		this.dom.video.loop = true;
		this.dom.video.muted = true;

		this.dom.video.addEventListener("loadedmetadata", () => {
			this.changeVideoTextSize(this.dom.video.videoHeight, this.dom.video.videoWidth);
		});

		const source = document.createElement("source");
		source.src = url;
		source.type = 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"';

		this.dom.video.appendChild(source);
		this.dom.video.innerHTML += "Тег video не поддерживается вашим браузером.";

		this.dom.content.appendChild(this.dom.video);
		this.domElement().prepend(this.dom.content);
	}

	reloadAssetAsync(asset) {
		this.asset = asset;
		const url = helperCreateObjectUrl(this.asset);

		this.dom.video.addEventListener("loadedmetadata", () => {
			this.changeVideoTextSize(this.dom.video.videoHeight, this.dom.video.videoWidth);
		});

		this.dom.video.src = url;
	}
}
